export class PaceError extends Error {}
